import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "color-picker-wrap" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "custom-picker-wrap" }

import { computed, ref } from 'vue';
import useCustomIcon from '@/utilities/composables/useCustomIcon';
import styleVariables from '@/assets/scss/variables.module.scss';


export default /*@__PURE__*/_defineComponent({
  __name: 'ColorPicker',
  props: {
    selectedColor: {},
    colors: { default: () => [
      styleVariables.pink500,
      styleVariables.error500,
      styleVariables.warning500,
      styleVariables.success500,
      styleVariables.primary500,
      styleVariables.purple500,
      styleVariables.gray500,
    ] }
  },
  emits: ['selectColor', 'pickerButtonClick', 'predefinedColorPick'],
  setup(__props: any, { emit: __emit }) {

const { iconPath, getCustomIconStyle } = useCustomIcon();

const colorPicker = ref();

const props = __props;

const emit = __emit;

const customColorSelected = computed(
  () => props.selectedColor && !props.colors.includes(props.selectedColor)
);

function pickerButtonClick() {
  colorPicker.value.value = props.selectedColor;
  colorPicker.value.click();
  emit('pickerButtonClick');
}

function selectColor(color: string) {
  emit('selectColor', color);
}

function predefinedColorClick(color: string) {
  selectColor(color);
  emit('predefinedColorPick', color);
}

function setCustomColor(event: Event) {
  const color = (event.target as HTMLInputElement).value || '#212121';
  selectColor(color);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colors, (color) => {
      return (_openBlock(), _createElementBlock("div", {
        key: color,
        style: _normalizeStyle({ background: color }),
        class: "item-color pt",
        onClick: _withModifiers(($event: any) => (predefinedColorClick(color)), ["stop"])
      }, [
        (_ctx.selectedColor === color)
          ? (_openBlock(), _createElementBlock("em", {
              key: 0,
              class: "w-4 h-4 bg-gray-50",
              style: _normalizeStyle(_unref(getCustomIconStyle)(_unref(iconPath)('check')))
            }, null, 4))
          : _createCommentVNode("", true)
      ], 12, _hoisted_2))
    }), 128)),
    _cache[2] || (_cache[2] = _createTextVNode()),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "custom-picker-button pt",
        onClick: _withModifiers(pickerButtonClick, ["stop"])
      }, [
        (customColorSelected.value)
          ? (_openBlock(), _createElementBlock("em", {
              key: 0,
              class: "w-4 h-4 bg-gray-50",
              style: _normalizeStyle(_unref(getCustomIconStyle)(_unref(iconPath)('check')))
            }, null, 4))
          : _createCommentVNode("", true),
        _cache[1] || (_cache[1] = _createTextVNode()),
        _createElementVNode("input", {
          ref_key: "colorPicker",
          ref: colorPicker,
          type: "color",
          class: "color-picker",
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
          onInput: setCustomColor
        }, null, 544)
      ])
    ])
  ]))
}
}

})